export default {
  'patient.groupByProfessional': 'Cadastro do paciente: Listar pacientes por profissional',
  'patient.identityRequired': 'Cadastro do paciente: Preenchimento obrigatório do campo documento (CPF/Passaporte)',
  'clinical.blockAppointmentInUse': 'Agenda: Bloquear agendamento quando em uso por outro atendente',
  'clinical.allowEditFinishedAppointment': 'Agenda: Permitir editar agendamentos finalizados',
  'clinical.requestProfessionalRequired': 'Agenda: Obrigatório informar o profissional solicitante quando for exame',
  'patient.birthDateRequired': 'Agenda: Preenchimento obrigatório do campo data de nascimento',
  'clinical.blockServiceWithoutAccount': 'Prontuário: Bloquear atendimento médico sem uma conta registrada',
  'medicalRecord.cidRequired': 'Prontuário: Obrigatório o preenchimento do campo CID',
  'attendance.medicalReport': 'Central de Laudos: Listar apenas os exames do profissional',
  'relationship.birthday': 'Automação: Enviar mensagem para aniversariantes',
  'relationship.schedulingPerformed': 'Automação: Enviar mensagem ao realizar um agendamento',
  'relationship.appointmentConfirmation': 'Automação: Enviar mensagem de confirmação de agendamento',
  'relationship.appointmentReminder': 'Automação: Enviar mensagem de lembrete de agendamento',
  'relationship.satisfactionSurvey': 'Automação: Envio de pesquisa de satisfação logo após o atendimento',
  'sphere.allowInvalidExpenses': 'Integração: Permitir agendamento de despesas não cadastradas',
  'sphere.allowSlotting': 'Integração: Permitir agendamento por encaixe',
  'pacs.enabled': 'Integração: Habilitar serviço de PACS',
};
